import { ActiveInactiveStatusEnum } from '../../../../../shared/enums/active-inactive-status.enum';
import { FirmwareOverviewModel } from '../../../../../shared/models/firmware-overview.model';
import { Alignments } from '../../../../shared/components/ui/Table/enums/alignments.enum';
import { TableColumnDef } from '../../../../shared/components/ui/Table/models/table-column.model';
import { TextToColorMapModel } from '../../../../shared/models/text-to-color-map.model';
import { castTo } from '../../../../shared/utils/cast-to';
import { MapToText } from '../../../../shared/utils/map-to-text/map-to-text.util';
import { firmwareOverviewStatusMap } from '../../../utils/firmware-overview-status.map';
import FirmwareDetailsCell from '../../FirmwareDetailsCell/FirmwareDetailsCell';

export const columns: TableColumnDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    alignment: Alignments.LEFT,
    width: '93.3%',
    valueGetter: row => (
      <FirmwareDetailsCell {...castTo<FirmwareOverviewModel>(row)} />
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    alignment: Alignments.RIGHT,
    width: '4%',
    valueGetter: row =>
      MapToText<ActiveInactiveStatusEnum, TextToColorMapModel>({
        map: firmwareOverviewStatusMap,
        property: row.status as ActiveInactiveStatusEnum,
        sx: {
          display: 'inline-block',
          marginTop: '22px',
        },
      }),
  },
];
